import Bootstrap from '../../assets/skills/bootstrap-4.svg'
import Css from '../../assets/skills/css3.svg'
import Express from '../../assets/skills/express.svg'
import Html5 from '../../assets/skills/html-5.svg'
import Javascript from '../../assets/skills/javascript.svg'
import Material_Ui from '../../assets/skills/material-ui-1.svg'
import MongoDb from '../../assets/skills/mongodb.svg'
import NodeJs from '../../assets/skills/nodejs.svg'
import React_Bootstrap from '../../assets/skills/react-bootstrap.svg'
import React_L from '../../assets/skills/react.svg'
import Redux_L from '../../assets/skills/redux.svg'
import Sass from '../../assets/skills/sass-1.svg'
import Styled_Comp from '../../assets/skills/styled-components.svg'
import Typescript from '../../assets/skills/typescript.svg'
import Firebase_L from '../../assets/skills/firebasepng.png'



export const skills = {
    frontend : [
        {
            link: "https://en.wikipedia.org/wiki/HTML5",
            imgAltText: "HTML 5",
            imgSrc: Html5,
            skillName: "HTML5",
        },
        {
            link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
            imgAltText: "CSS 3",
            imgSrc: Css,
            skillName: "CSS3",
        },
        {
            link: "https://www.javascript.com/",
            imgAltText: "JavaScript",
            imgSrc: Javascript,
            skillName: "JavaScript",
        },
        {
            link: "https://sass-lang.com/",
            imgAltText: "Sass",
            imgSrc: Sass,
            skillName: "Sass",
          },
          {
            link: "https://getbootstrap.com/",
            imgAltText: "Bootstrap",
            imgSrc: Bootstrap,
            skillName: "Bootstrap",
          },
          {
            link: "https://reactjs.org/",
            imgAltText: "React JS",
            imgSrc: React_L,
            skillName: "React JS",
          },
          {
            link: "https://redux.js.org/",
            imgAltText: "Redux",
            imgSrc: Redux_L,
            skillName: "Redux",
          },
          {
            link: "https://material-ui.com/",
            imgAltText: "Material-UI",
            imgSrc: Material_Ui,
            skillName: "Material-UI",
          },
          {
            link: "https://react-bootstrap.github.io/",
            imgAltText: "React Bootstrap",
            imgSrc: React_Bootstrap,
            skillName: "React Bootstrap",
          },
          {
            link: "https://styled-components.com/",
            imgAltText: "styled-components",
            imgSrc: Styled_Comp,
            skillName: "styled-components",
          },

    ],
    backend: [
        {
          link: "https://nodejs.org/en/",
          imgAltText: "Node.js",
          imgSrc: NodeJs,
          skillName: "Node.js",
        },
        {
          link: "https://expressjs.com/",
          imgAltText: "Express",
          imgSrc: Express,
          skillName: "Express",
        },
      ],
      programmingLanguages: [
        {
          link: "https://www.javascript.com/",
          imgAltText: "JavaScript",
          imgSrc: Javascript,
          skillName: "JavaScript",
        },
        {
          link: "https://www.typescriptlang.org/",
          imgAltText: "TypeScript",
          imgSrc: Typescript,
          skillName: "TypeScript",
        },
      ],
      databases: [
        {
          link: "https://www.mongodb.com/",
          imgAltText: "MongoDB",
          imgSrc: MongoDb,
          skillName: "MongoDB",
        },
        {
          link: "https://firebase.google.com/?gclid=Cj0KCQiA6Or_BRC_ARIsAPzuer8eyMy0p8H7213XZlxFteviK3rJwdSNiySTRzll25AvcS-7o2yp92UaAgK5EALw_wcB",
          imgAltText: "Firebase",
          imgSrc: Firebase_L,
          skillName: "Firebase",
        },
      ],
}